/**
 * Created by alvinoktavianus on 6/7/17.
 */

import React, { Component } from 'react';
import _ from 'lodash';
import { connect } from 'react-redux';
import { Field, getFormValues, reduxForm } from 'redux-form';
import moment from 'moment';
import { currencyFormatter, useMokaOutletPropsFirst } from 'utils/formatter';
import withFeatureFlags from 'hocs/withFeatureFlags';

import {
  onChangeSubscriptionRules,
  setTotalBillingPrice,
  onSetActiveSubcription,
  verifyCouponBilling,
  verifyCouponBillingV2,
  setExtendDate,
  hideMarkSubscriptionModal,
  onClickUpdateIsActiveSubcription,
  setTotalOutletPrice,
  setTotalFeaturePrice,
  setShowSlotEmployee,
  setIsExtendedStaffSlots,
  sendClevertapBillingInfoOnPageLoad,
  setProratePricePeriods,
  setStaffSlotsPrice,
} from 'actions/setting/billing';
import TurnOn from 'assets/images/turn_on.png';
import TurnOff from 'assets/images/turn_off.png';
import CheckIcon from 'assets/images/checklist.png';
import MinusIcon from 'assets/images/minus.png';
import MarkAsNonActiveSubscriptionModal from 'components/MarkAsNonActiveSubscriptionModal';
import DropdownSelect from './DropdownSelect';
import styles from './style.css';

const StaffSlotsBilling = props => {
  const {
    featurePrice,
    currentRules,
    purchasedStaffs,
    isExtended,
    extendDate,
    isEnterprise,
  } = props;
  const price =
    (featurePrice['Slot Employee'] -
      (currentRules.discount / 100) * featurePrice['Slot Employee']) *
    purchasedStaffs.length;
  const turnStaffImg = isExtended ? CheckIcon : MinusIcon;

  return (
    <div className={styles['staff-slots']}>
      <hr />
      <div className="row">
        <div className="col-md-1 col-xs-1 col-sm-1 col-lg-1">
          <input
            type="image"
            src={isEnterprise ? MinusIcon : turnStaffImg}
            className={styles['turn-on-off']}
            onClick={e => {
              e.preventDefault();
            }}
          />
        </div>
        <div className="col-md-4 col-xs-10 col-sm-5 col-lg-5">
          <p
            className={`${styles['outlet-name-elipsis']} ${
              !isExtended ? styles.inactive : ''
            }`}
          >
            <strong>Staff Slots</strong>
          </p>
        </div>
        <div className="col-md-3 col-xs-6 col-sm-3 col-lg-3">
          <p
            className={`${styles['outlet-name-elipsis']} ${
              !isExtended ? styles.inactive : ''
            }`}
          >
            {purchasedStaffs.length} Slots
          </p>
        </div>
        {!isEnterprise && (
          <div
            className={`col-md-4 col-xs-6 col-sm-3 col-lg-3 ${
              styles['price-mobi']
            }`}
          >
            <p className={`pull-right ${!isExtended ? styles.inactive : ''}`}>
              {currencyFormatter(price)}/mo
            </p>
          </div>
        )}
      </div>
      {!isExtended && (
        <div className="row">
          <div className="col-md-1 col-xs-1 col-sm-1 col-lg-1" />
          <div className="col-md-4 col-xs-10 col-sm-5 col-lg-5">
            <p className={`${styles['paid-until']}`}>
              {`Paid for until ${moment(extendDate).format('DD/MM/YYYY')}`}
            </p>
          </div>
        </div>
      )}
    </div>
  );
};

const BillingEachOutlet = props => {
  const {
    outlets,
    featurePrice,
    featureStatus,
    mokaPrice,
    currentRules,
    dispatch,
    isDeleted,
    isProgressCursor,
    outletMinMaxDate,
    endOfNextPlan,
    rules,
    expired,
    purchasedStaffs,
    isEnterprise,
  } = props;

  const calculatePrice = (price, discount) => {
    return price - (discount / 100) * price;
  };
  const formatDate = date => {
    return moment(date).format('DD/MM/YYYY');
  };

  return (
    <div>
      {_.map(outlets, outlet => {
        return (
          <div key={outlet.id}>
            <div className="row">
              <div className="col-md-1 col-xs-1 col-sm-1 col-lg-1">
                {!isEnterprise && !isDeleted[outlet.id] && (
                  <input
                    type="image"
                    src={TurnOn}
                    className={`${styles['turn-on-off']} ${
                      isProgressCursor
                        ? styles.show_progress_cursor
                        : styles.hide_progress_cursor
                    }`}
                    onClick={event => {
                      event.preventDefault();
                      if (!isProgressCursor) {
                        dispatch(
                          onClickUpdateIsActiveSubcription(
                            outlet.id,
                            isDeleted,
                            currentRules,
                            expired,
                            rules,
                            purchasedStaffs[0],
                            outlets,
                            true
                          )
                        );
                      }
                    }}
                    onKeyDown={event => {
                      if (event.keyCode === 13) {
                        event.preventDefault();
                      }
                    }}
                  />
                )}
                {!isEnterprise && isDeleted[outlet.id] && (
                  <input
                    type="image"
                    src={TurnOff}
                    className={`${styles['turn-on-off']} ${
                      isProgressCursor
                        ? styles.show_progress_cursor
                        : styles.hide_progress_cursor
                    }`}
                    onClick={event => {
                      event.preventDefault();
                      if (!isProgressCursor) {
                        dispatch(
                          onClickUpdateIsActiveSubcription(
                            outlet.id,
                            isDeleted,
                            currentRules,
                            expired,
                            rules,
                            purchasedStaffs[0],
                            outlets,
                            false
                          )
                        );
                      }
                    }}
                    onKeyDown={event => {
                      if (event.keyCode === 13) {
                        event.preventDefault();
                      }
                    }}
                  />
                )}
                {isEnterprise && (
                  <input
                    type="image"
                    src={MinusIcon}
                    className={`${styles['turn-on-off']} ${
                      isProgressCursor
                        ? styles.show_progress_cursor
                        : styles.hide_progress_cursor
                    }`}
                    onClick={event => {
                      event.preventDefault();
                    }}
                    onKeyDown={event => {
                      if (event.keyCode === 13) {
                        event.preventDefault();
                      }
                    }}
                  />
                )}
              </div>
              <div className="col-md-4 col-xs-10 col-sm-5 col-lg-5">
                <p
                  className={`${
                    currentRules.discount > 0
                      ? styles['outlet-name-elipsis']
                      : styles['outlet-name-mobi']
                  } ${isDeleted[outlet.id] ? styles.inactive : ''}`}
                >
                  <strong>
                    {useMokaOutletPropsFirst(outlet, o => o.name)}
                  </strong>
                </p>
              </div>
              <div className="col-md-3 col-xs-6 col-sm-3 col-lg-3">
                {!isEnterprise && currentRules.discount > 0 && (
                  <p
                    className={`text-red text-left ${
                      isDeleted[outlet.id] ? styles['inactive-red'] : ''
                    }`}
                  >
                    <del>{currencyFormatter(mokaPrice)}</del>
                  </p>
                )}
              </div>
              {!isEnterprise && (
                <div
                  className={`col-md-4 col-xs-6 col-sm-3 col-lg-3 ${
                    currentRules.discount > 0 ? '' : styles['price-mobi']
                  }`}
                >
                  <p
                    className={`pull-right ${
                      isDeleted[outlet.id] ? styles.inactive : ''
                    }`}
                  >
                    {currencyFormatter(
                      calculatePrice(mokaPrice, currentRules.discount)
                    )}
                    /mo
                  </p>
                </div>
              )}
            </div>

            {_.map(featureStatus, feature => {
              if (feature.isFeatureNeedToBePaid) {
                return (
                  <div className="row">
                    <div className="col-md-1 col-xs-1 col-sm-1 col-lg-1" />
                    <div className="col-md-4 col-xs-10 col-sm-5 col-lg-5">
                      <p
                        className={`${
                          isDeleted[outlet.id] ? styles.inactive : ''
                        } ${styles['mb-0px']}`}
                      >
                        <p
                          className={
                            currentRules.discount > 0
                              ? styles['feature-name']
                              : styles['feature-name-elipsis']
                          }
                        >
                          {feature.display_name}
                        </p>
                      </p>
                    </div>
                    <div className="col-md-3 col-xs-6 col-sm-3 col-lg-3">
                      {!isEnterprise &&
                        currentRules.discount > 0 &&
                        featurePrice[feature.name] > 0 && (
                          <p
                            className={`text-red text-left ${
                              isDeleted[outlet.id] ? styles['inactive-red'] : ''
                            }`}
                          >
                            <del>
                              {currencyFormatter(featurePrice[feature.name])}
                            </del>
                          </p>
                        )}
                    </div>
                    {!isEnterprise && (
                      <div
                        className={`col-md-4 col-xs-6 col-sm-3 col-lg-3 ${
                          currentRules.discount > 0 ? '' : styles['price-mobi']
                        }`}
                      >
                        <p
                          className={`pull-right ${
                            isDeleted[outlet.id] ? styles.inactive : ''
                          }`}
                        >
                          {currencyFormatter(
                            calculatePrice(
                              featurePrice[feature.name],
                              currentRules.discount
                            )
                          )}
                          /mo
                        </p>
                      </div>
                    )}
                  </div>
                );
              }
            })}

            {outletMinMaxDate.minDate === outletMinMaxDate.maxDate
              ? false
              : formatDate(outlet.end_date) !== outletMinMaxDate.maxDate &&
                !isDeleted[outlet.id] && (
                  <div className="row">
                    {!isEnterprise && (
                      <div className="prorated-box">
                        <div className="col-md-1 col-xs-1 col-sm-1 col-lg-1" />
                        <div className="col-md-6 col-xs-10 col-sm-6 col-lg-6">
                          <div className={`${styles['billing-pro-rated']}`}>
                            <p className="text-left no-margin">
                              Prorated From : {formatDate(outlet.end_date)} to{' '}
                              {endOfNextPlan}
                            </p>
                          </div>
                        </div>
                      </div>
                    )}
                  </div>
                )}
          </div>
        );
      })}
    </div>
  );
};

class BillingReceiptForm extends Component {
  componentWillUpdate(nextProps) {
    const activeOutletLongestDate = moment(
      nextProps.outletMinMaxDate.maxDate,
      'DD/MM/YYYY'
    ).add(nextProps.currentSubscriptionRules.month, 'month');
    const outletWithLongestDate = moment(
      nextProps.minMaxAllOutlet.maxDate,
      'DD/MM/YYYY'
    );
    if (activeOutletLongestDate.isAfter(outletWithLongestDate)) {
      nextProps.dispatch(setShowSlotEmployee(true));
      nextProps.dispatch(setIsExtendedStaffSlots(true));
    } else {
      nextProps.dispatch(setShowSlotEmployee(false));
      nextProps.dispatch(setIsExtendedStaffSlots(false));
    }
  }

  componentDidMount() {
    const { totalOutletPrice, outlets, currentSubscriptionRules } = this.props;
    this.props.dispatch(
      sendClevertapBillingInfoOnPageLoad(
        totalOutletPrice,
        outlets,
        currentSubscriptionRules
      )
    );
  }

  render() {
    const {
      isValidatingCoupon,
      couponErrorMessage,
      couponDiscount,
      isCouponValid,
      rules,
      currentSubscriptionRules,
      handleSubmit,
      payButtonClicked,
      buttonMessage,
      pendingPaymentMessage,
      unusedOutletMessage,
      featureSubscriptionStatus,
      featureSubscriptionPrice,
      outlets,
      dispatch,
      isDeleted,
      purchasedStaffs,
      isExtended,
      isProgressCursor,
      outletMinMaxDate,
      expired,
      showProrate,
      extendDate,
      totalBillingPrice,
      showMarkSubscriptionModal,
      showSlotEmployee,
      isEnterprise,
      isMokaposUser,
      billingCouponV2Enabled,
    } = this.props;
    const subscriptionRules = _.mapKeys(rules.subscription_plans, 'name');
    let totalDiscount = 0;
    let amountCoupon = '0';

    let anyActiveOutlets = false;
    if (couponDiscount) {
      if (billingCouponV2Enabled) {
        totalDiscount = !_.isEmpty(couponDiscount)
          ? couponDiscount.totalDiscountAmount
          : 0;
        amountCoupon = !_.isEmpty(couponDiscount)
          ? `${couponDiscount.totalDiscountPercentage}%`
          : currencyFormatter(totalDiscount);
      } else {
        totalDiscount = !_.isEmpty(couponDiscount)
          ? Math.floor(couponDiscount.total)
          : 0;
        amountCoupon =
          couponDiscount.type === 'PERCENTAGE'
            ? `${couponDiscount.amount}%`
            : currencyFormatter(totalDiscount);
      }
    }
    _.forEach(outlets, outlet => {
      if (isDeleted[outlet.id] === false) {
        anyActiveOutlets = true;
      }
    });
    return (
      <div
        className={`${styles['billing-receipt-form-wrapper']} ${
          isProgressCursor
            ? styles.show_progress_cursor
            : styles.hide_progress_cursor
        }`}
      >
        <form onSubmit={handleSubmit}>
          <div className={styles['billing-receipt-slot']} />
          <div className={`${styles['billing-receipt-paper']}`}>
            {!isMokaposUser && (
              <div className={styles['mokapay-view']}>
                <div className={styles['mokapay-tab']}>
                  <img
                    src="https://s3-ap-southeast-1.amazonaws.com/image.mokapos.com/growth/backoffice/billing/billing-asset.png"
                    alt="pos"
                  />
                </div>
                <p>
                  Contact support@mokapos.com to upgrade your account to Moka
                  POS and enjoy more features to grow your business
                </p>
              </div>
            )}
            {isMokaposUser && (
              <div>
                <div className={styles['billing-receipt-paper-box']}>
                  <div className="row">
                    <div className="col-md-3 col-sm-6">
                      <span className={styles['text-vertically-aligned']}>
                        Billing Cycle
                      </span>
                    </div>
                    <div className="col-md-4 col-sm-6">
                      <Field
                        name="subscriptionRules"
                        component={DropdownSelect}
                        options={subscriptionRules}
                        defaultOptionKey={{ name: 'Moka 12 Months' }}
                        className="dropdown-select-subscription-rules"
                        id="changeSubscriptionRules"
                        onChange={this._onChangeSubscriptionRules}
                      />
                    </div>
                  </div>
                </div>
                <div className={styles['billing-receipt-paper-box']}>
                  <h4 className={styles['mb-20px']}>
                    OUTLETS : {this._calculateTotalOutlet()}
                  </h4>
                  {showSlotEmployee &&
                    anyActiveOutlets &&
                    purchasedStaffs.length > 0 && (
                      <StaffSlotsBilling
                        featurePrice={featureSubscriptionPrice}
                        currentRules={currentSubscriptionRules}
                        purchasedStaffs={purchasedStaffs}
                        outlets={outlets}
                        isExtended={isExtended}
                        extendDate={extendDate}
                        isEnterprise={isEnterprise}
                      />
                    )}
                  <hr />
                  <BillingEachOutlet
                    outlets={outlets}
                    featureStatus={featureSubscriptionStatus}
                    featurePrice={featureSubscriptionPrice}
                    mokaPrice={rules.moka_price}
                    currentRules={currentSubscriptionRules}
                    dispatch={dispatch}
                    isDeleted={isDeleted}
                    isProgressCursor={isProgressCursor}
                    outletMinMaxDate={outletMinMaxDate}
                    endOfNextPlan={this._endOfNextPlan('DD/MM/YYYY')}
                    expired={expired}
                    rules={rules}
                    showProrate={showProrate}
                    purchasedStaffs={purchasedStaffs}
                    showMarkSubscriptionModal={showMarkSubscriptionModal}
                    isEnterprise={isEnterprise}
                  />
                </div>
                <div className={styles['billing-receipt-paper-box']}>
                  {this._calculateTotalOutlet() > 0 && (
                    <div>
                      {!isEnterprise && totalDiscount > 0 && (
                        <div>
                          <div className={`text-primary row`}>
                            <div className="col-md-7 col-xs-6">
                              <h5>Sub Total</h5>
                            </div>
                            <div className="col-md-5 col-xs-6">
                              <h5 className="pull-right">
                                {currencyFormatter(
                                  totalBillingPrice + totalDiscount
                                )}
                              </h5>
                            </div>
                          </div>
                          <div className={`text-primary row`}>
                            <div className="col-md-7 col-xs-6">
                              <h5>Coupon Discount</h5>
                            </div>
                            <div className="col-md-5 col-xs-6">
                              <h5 className="pull-right">
                                {currencyFormatter(-totalDiscount)}
                              </h5>
                            </div>
                          </div>
                        </div>
                      )}
                      {!isEnterprise && (
                        <div className={`text-primary row`}>
                          <div className="col-md-7 col-xs-6">
                            <h4>Total Amount</h4>
                          </div>
                          <div className="col-md-5 col-xs-6">
                            <h4 className="pull-right">
                              {currencyFormatter(this._calculateTotalPrice())}
                            </h4>
                          </div>
                        </div>
                      )}
                      <div className={`row ${styles['mb-30px']}`}>
                        <div className="col-md-7 col-xs-6">
                          <div className={styles['text-xs']}>
                            <em>Your expiration date will be extended to</em>
                          </div>
                          <div className={styles['text-xs']}>
                            <strong>
                              <em>
                                {isMokaposUser
                                  ? this._endOfNextPlan('D MMMM YYYY')
                                  : 'N/A'}
                              </em>
                            </strong>
                          </div>
                        </div>
                        <div className={`col-md-5 col-xs-6`}>
                          {!isEnterprise &&
                            currentSubscriptionRules.discount > 0 && (
                              <div>
                                <div
                                  className={`pull-right ${
                                    styles['text-green']
                                  }`}
                                >
                                  <strong>
                                    <em>
                                      Save {currentSubscriptionRules.discount}%
                                    </em>
                                  </strong>
                                </div>
                                <br />
                                {amountCoupon !== '0' &&
                                  amountCoupon !== 'Rp. 0' && (
                                    <div
                                      className={`pull-right ${
                                        styles['text-green']
                                      }`}
                                    >
                                      <strong>
                                        <em>+ Disc {amountCoupon}</em>
                                      </strong>
                                    </div>
                                  )}
                              </div>
                            )}
                        </div>
                      </div>
                      {!isEnterprise && !isCouponValid && (
                        <div className={`row ${styles['coupon-alert']}`}>
                          {couponErrorMessage}
                        </div>
                      )}
                      {!isEnterprise && (
                        <div className={`row ${styles['coupon-container']}`}>
                          <Field
                            component="input"
                            type="text"
                            name="coupon"
                            placeholder="Insert coupon code"
                            className={`${styles['input-coupon']} form-control`}
                            normalize={this._toUpperCase}
                            onKeyDown={this._onKeyDown}
                          />
                          <button
                            className={`btn btn-primary`}
                            onClick={this._onClickValidateCoupon}
                            type="button"
                            disabled={isValidatingCoupon}
                          >
                            {isValidatingCoupon ? 'Applying . . .' : 'Apply'}
                          </button>
                        </div>
                      )}
                    </div>
                  )}
                  <div className="row">
                    {!isEnterprise && (
                      <div
                        className={`col-md-12 ${
                          this._calculateTotalOutlet() !== 0
                            ? styles['btn-pay']
                            : ''
                        }`}
                      >
                        <button
                          className={`btn btn-lg btn-block ${
                            !isMokaposUser ||
                            this._calculateTotalOutlet() === 0 ||
                            payButtonClicked
                              ? 'btn-disabled'
                              : 'btn-primary'
                          }`}
                          type="submit"
                          id="pay-button"
                          disabled={
                            !isMokaposUser ||
                            this._calculateTotalOutlet() === 0 ||
                            payButtonClicked
                          }
                        >
                          {buttonMessage}
                        </button>
                      </div>
                    )}
                    {isEnterprise && (
                      <div className={`col-md-12`}>
                        <div className={`${styles['is-enterprise']}`}>
                          <p>
                            For more details on your bill, please contact your
                            sales representative or contact customer support at
                            1500970
                          </p>
                        </div>
                      </div>
                    )}
                  </div>
                  {!isEnterprise && pendingPaymentMessage !== null && (
                    <div
                      className={`row ${styles['mt-10px']} ${
                        styles['text-xs']
                      } text-red`}
                    >
                      <div className="col-md-12">
                        <em>{pendingPaymentMessage}</em>
                      </div>
                    </div>
                  )}
                  {!isEnterprise && unusedOutletMessage !== null && (
                    <div
                      className={`row ${styles['mt-10px']} ${
                        styles['text-xs']
                      } text-red`}
                    >
                      <div className="col-md-12">
                        <em>{unusedOutletMessage}</em>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            )}
          </div>
        </form>
        {showMarkSubscriptionModal && (
          <MarkAsNonActiveSubscriptionModal
            showModal={showMarkSubscriptionModal}
            hideModal={this._onHideModal}
            deactiveOutlet={this._onClickDeactiveModal}
          />
        )}
      </div>
    );
  }

  _onHideModal = () => {
    this.props.dispatch(hideMarkSubscriptionModal());
  };

  _onClickDeactiveModal = () => {
    const { paramsDeactive } = this.props;
    this.props.dispatch(onSetActiveSubcription(paramsDeactive));
  };

  _toUpperCase = value => {
    return value.toUpperCase();
  };

  _onKeyDown = e => {
    if (e.keyCode === 13) {
      e.preventDefault();
      e.stopPropagation();
      this._onClickValidateCoupon(e);
    }
  };

  _onChangeSubscriptionRules = (event, subscriptionRules) => {
    const { rules, outletMinMaxDate, minMaxAllOutlet } = this.props;
    const subscription = _.mapKeys(rules.subscription_plans, 'name');
    this.props.dispatch(
      onChangeSubscriptionRules(
        subscription[subscriptionRules],
        outletMinMaxDate,
        minMaxAllOutlet
      )
    );
  };

  _onClickValidateCoupon = event => {
    const {
      currentSubscriptionRules,
      rules,
      businessId,
      businessTypeId,
      businessCategoryId,
      featureSubscriptionStatus,
      featureSubscriptionPrice,
      totalOutletPrice,
      totalFeaturePrice,
      billingCouponV2Enabled,
      outletMinMaxDate,
      proratePricePeriods,
      staffSlotsPrice,
    } = this.props;
    event.preventDefault();
    const { coupon, subscriptionRules } = this.props.billingForm;
    if (coupon !== '') {
      let subscriptionType = '';
      if (subscriptionRules === 'Moka 12 Months') {
        subscriptionType = 'ANNUAL';
      } else {
        subscriptionType = 'MONTHLY';
      }

      let subscription = {};

      if (rules.subscription_plans.length === 1) {
        [subscription] = rules.subscription_plans;
      } else {
        subscription = currentSubscriptionRules;
      }

      const outletCount = this._calculateTotalOutlet();

      if (billingCouponV2Enabled) {
        const mokaPrice =
          rules.moka_price - (subscription.discount / 100) * rules.moka_price;

        let monthRules = 0;
        if (subscription.month) {
          monthRules = subscription.month;
        }

        let featuresForCoupon;
        let totalOutletPriceForCoupon = mokaPrice * outletCount * monthRules;

        // if prorated
        if (outletMinMaxDate.minDate !== outletMinMaxDate.maxDate) {
          // outlet price
          // proratePricePeriods only contains the "prorate part" prices, thus need to add with regular monthRules price
          totalOutletPriceForCoupon += _.sum(
            proratePricePeriods.map(p => p.total_outlet_price)
          );
          featuresForCoupon = featureSubscriptionStatus
            .filter(f => f.isFeatureNeedToBePaid && f.name !== 'Slot Employee')
            .map(f => {
              const featurePrice =
                featureSubscriptionPrice[f.name] -
                (subscription.discount / 100) *
                  featureSubscriptionPrice[f.name];
              let featureTotalPrice = featurePrice * outletCount * monthRules;

              // again same with the outlets, need to add with regular featurePrice * outlet * month
              // as the proratePricePeriods only contains the "prorate part" prices
              const featureNeedToBePaid = proratePricePeriods.flatMap(
                p => p.feature_need_tobe_paid
              );

              // adding prorate sum of per month price
              featureTotalPrice += _.sum(
                featureNeedToBePaid
                  .filter(p => p.name === f.name)
                  .map(p => p.total)
              );

              // adding prorate sum of per day price
              featureTotalPrice += _.sum(
                featureNeedToBePaid
                  .filter(p => p.feature_name === f.name)
                  .map(p => p.total_price)
              );

              return {
                name: f.name
                  .split(' ')
                  .join('_')
                  .toUpperCase(),
                total_price: featureTotalPrice,
              };
            });
        } else {
          // just directly multiply, get each feature price from redux store

          featuresForCoupon = featureSubscriptionStatus
            .filter(f => f.isFeatureNeedToBePaid && f.name !== 'Slot Employee')
            .map(f => {
              let featureTotalPrice =
                featureSubscriptionPrice[f.name] * outletCount * monthRules;
              featureTotalPrice -=
                featureTotalPrice * (subscription.discount / 100);
              return {
                name: f.name
                  .split(' ')
                  .join('_')
                  .toUpperCase(),
                total_price: featureTotalPrice,
              };
            });
        }

        if (staffSlotsPrice && staffSlotsPrice > 0) {
          featuresForCoupon.push({
            name: 'SLOT_EMPLOYEE',
            total_price: staffSlotsPrice,
          });
        }

        const params = {
          coupon,
          businessId,
          businessTypeId,
          businessCategoryId,
          totalOutletPrice: totalOutletPriceForCoupon,
          subscriptionType,
          features: featuresForCoupon,
          outletCount,
        };

        this.props.dispatch(verifyCouponBillingV2(params));
      } else {
        const features = _.map(
          _.partition(featureSubscriptionStatus, {
            isFeatureNeedToBePaid: true,
          })[0],
          features => {
            return {
              name: features.name
                .split(' ')
                .join('_')
                .toUpperCase(),
              outlet_count: outletCount,
              unit_price:
                (featureSubscriptionPrice[features.name] *
                  (100 - subscription.discount)) /
                100,
            };
          }
        );

        const monthBySubscriptionType = subscriptionType === 'ANNUAL' ? 12 : 1;
        const unitPrice =
          totalOutletPrice / outletCount / monthBySubscriptionType;

        const params = {
          coupon,
          businessId,
          businessTypeId,
          baseSubscription: {
            name: subscriptionType,
            outlet_count: outletCount,
            unit_price: unitPrice,
          },
          features,
          totalBillingPrice: totalOutletPrice + totalFeaturePrice,
        };
        this.props.dispatch(verifyCouponBilling(params));
      }
    }
  };

  _calculateTotalOutlet = () => {
    const { outlets, isDeleted } = this.props;
    let totalOutlets = 0;
    _.map(outlets, outlet => {
      if (!isDeleted[outlet.id]) totalOutlets++;
    });
    return totalOutlets;
  };

  _calculateTotalPrice = () => {
    const {
      currentSubscriptionRules,
      rules,
      featureSubscriptionStatus,
      featureSubscriptionPrice,
      outlets,
      isDeleted,
      couponDiscount,
      purchasedStaffs,
      isExtended,
      outletMinMaxDate,
      extendDate,
      minMaxAllOutlet,
      billingCouponV2Enabled,
    } = this.props;
    if (!currentSubscriptionRules || !rules) {
      return 0;
    }
    let subscription = {};

    if (rules.subscription_plans.length === 1) {
      [subscription] = rules.subscription_plans;
    } else {
      subscription = currentSubscriptionRules;
    }

    let discount;
    if (billingCouponV2Enabled) {
      discount = isNaN(couponDiscount.totalDiscountAmount)
        ? 0
        : couponDiscount.totalDiscountAmount;
    } else {
      discount = isNaN(Math.floor(couponDiscount.total))
        ? 0
        : Math.floor(couponDiscount.total);
    }

    const mokaPrice =
      rules.moka_price - (subscription.discount / 100) * rules.moka_price;
    let monthRules = 0;
    const maxDate = moment(outletMinMaxDate.maxDate, 'DD/MM/YYYY');
    let featurePrice = 0;
    const activeOutlets = [];
    let staffSlotsPrice = 0;
    let periods = [];
    if (subscription.month) {
      monthRules = subscription.month;
    }

    _.forEach(outlets, outlet => {
      if (!isDeleted[outlet.id]) {
        activeOutlets.push(outlet);
      }
    });
    let totalOutletPricePeriod = 0;
    let totalFeaturePricePeriod = 0;
    let totalPricePeriod = 0;

    _.forEach(featureSubscriptionStatus, feature => {
      if (feature.isFeatureNeedToBePaid && !feature.isTrial) {
        featurePrice +=
          featureSubscriptionPrice[feature.name] -
          (subscription.discount / 100) *
            featureSubscriptionPrice[feature.name];
      }
    });

    if (outletMinMaxDate.minDate !== outletMinMaxDate.maxDate) {
      periods = BillingReceiptForm._getProrate(
        activeOutlets,
        maxDate,
        mokaPrice,
        featureSubscriptionStatus,
        featureSubscriptionPrice,
        subscription
      );
      periods.map(function(period) {
        totalOutletPricePeriod += period.total_outlet_price;
        totalFeaturePricePeriod += period.total_feature_price;
      });
      totalOutletPricePeriod =
        totalOutletPricePeriod + mokaPrice * activeOutlets.length * monthRules;
      totalFeaturePricePeriod =
        totalFeaturePricePeriod +
        featurePrice * activeOutlets.length * monthRules;
      totalPricePeriod = totalOutletPricePeriod + totalFeaturePricePeriod;
    } else {
      totalOutletPricePeriod = mokaPrice * activeOutlets.length * monthRules;
      totalFeaturePricePeriod =
        featurePrice * activeOutlets.length * monthRules;
      totalPricePeriod = totalOutletPricePeriod + totalFeaturePricePeriod;
      periods.push({
        start: outletMinMaxDate.minDate,
        end: extendDate,
        total_price: totalPricePeriod,
        total_outlet_price: totalOutletPricePeriod,
        total_feature_price: totalFeaturePricePeriod,
        feature_need_tobe_paid: [],
        total_extend_slot: 0,
      });
    }

    if (isExtended) {
      let maxDateWithoutFilter = moment(minMaxAllOutlet.maxDate, 'DD/MM/YYYY');
      const currentExtendDAte = moment(
        outletMinMaxDate.maxDate,
        'DD/MM/YYYY'
      ).add(monthRules, 'M');
      const staffSlotPricePerMonth =
        featureSubscriptionPrice['Slot Employee'] -
        (subscription.discount / 100) *
          featureSubscriptionPrice['Slot Employee'];
      if (currentExtendDAte.isAfter(maxDateWithoutFilter)) {
        const copyMaxDateWithoutFilter = _.cloneDeep(maxDateWithoutFilter);
        copyMaxDateWithoutFilter.add(monthRules, 'M');
        if (copyMaxDateWithoutFilter.isSame(currentExtendDAte)) {
          staffSlotsPrice =
            staffSlotPricePerMonth * monthRules * purchasedStaffs.length;
        } else {
          let index = 1;
          while (maxDateWithoutFilter.isBefore(currentExtendDAte)) {
            maxDateWithoutFilter.add(1, 'M');
            if (maxDateWithoutFilter.isAfter(currentExtendDAte)) {
              maxDateWithoutFilter.add(-1, 'M');
              const daysLeft = currentExtendDAte.diff(
                maxDateWithoutFilter,
                'days'
              );
              const daysInMonth = maxDateWithoutFilter.daysInMonth();
              const staffSlotPricePerDay =
                (staffSlotPricePerMonth / daysInMonth) * purchasedStaffs.length;
              staffSlotsPrice += parseInt(staffSlotPricePerDay * daysLeft);
              maxDateWithoutFilter = currentExtendDAte;
            } else {
              staffSlotsPrice =
                staffSlotsPrice +
                staffSlotPricePerMonth * purchasedStaffs.length;
              index = index + 1;
            }
          }
        }
      }
    }
    this.props.dispatch(setTotalOutletPrice(totalOutletPricePeriod));
    this.props.dispatch(setTotalFeaturePrice(totalFeaturePricePeriod));
    const totalPrice = isNaN(totalPricePeriod)
      ? 0
      : totalPricePeriod + staffSlotsPrice;
    this.props.dispatch(setTotalBillingPrice(totalPrice - discount));

    if (this.props.billingCouponV2Enabled) {
      this.props.dispatch(setProratePricePeriods(periods));
      this.props.dispatch(setStaffSlotsPrice(staffSlotsPrice));
    }

    return totalPrice - discount;
  };

  static _getProrate(
    activeOutlets,
    maxDate,
    mokaPrice,
    featureSubscriptionStatus,
    featureSubscriptionPrice,
    subscription
  ) {
    const resultProrate = [];
    activeOutlets.map(function(outlet) {
      let currentState = moment(outlet.end_date);
      const endDate = maxDate;

      if (!currentState.isSame(endDate)) {
        while (currentState.isBefore(endDate)) {
          const nextState = _.cloneDeep(currentState);
          nextState.add(1, 'M');
          let featurePriceProrate = 0.0;
          if (nextState.isAfter(maxDate)) {
            const daysLeft = Math.abs(endDate.diff(currentState, 'days'));
            const totalOutletPrice = parseInt(
              (daysLeft / Math.abs(nextState.diff(currentState, 'days'))) *
                mokaPrice
            );
            let totalFeaturePrice = 0;
            const result = {
              start: nextState.toDate(),
              end: endDate.toDate(),
              total_price: 0,
              total_outlet_price: totalOutletPrice,
              total_feature_price: 0,
              feature_need_tobe_paid: [],
              total_extend_slot: 0,
            };
            _.forEach(featureSubscriptionStatus, feature => {
              if (feature.isFeatureNeedToBePaid) {
                const featurePrice =
                  featureSubscriptionPrice[feature.name] -
                  (subscription.discount / 100) *
                    featureSubscriptionPrice[feature.name];
                featurePriceProrate = parseInt(
                  (daysLeft / Math.abs(nextState.diff(currentState, 'days'))) *
                    featurePrice
                );
                totalFeaturePrice += featurePriceProrate;
                result.feature_need_tobe_paid.push({
                  feature_name: feature.name,
                  total_price: featurePriceProrate,
                });
              }
            });
            result.total_feature_price = totalFeaturePrice;
            result.total_price = totalOutletPrice + totalFeaturePrice;
            resultProrate.push(result);
            currentState = endDate;
          } else {
            let totalFeaturePricePerMonth = 0;
            const result = {
              start: currentState.toDate(),
              end: nextState.toDate(),
              total_price: 0,
              total_outlet_price: mokaPrice,
              total_feature_price: 0,
              feature_need_tobe_paid: [],
              total_extend_slot: 0,
            };
            _.forEach(featureSubscriptionStatus, feature => {
              if (feature.isFeatureNeedToBePaid) {
                const featurePricePerMonth =
                  featureSubscriptionPrice[feature.name] -
                  (subscription.discount / 100) *
                    featureSubscriptionPrice[feature.name];
                totalFeaturePricePerMonth += featurePricePerMonth;
                result.feature_need_tobe_paid.push({
                  name: feature.name,
                  days_left: '1 month',
                  total: featurePricePerMonth,
                });
              }
            });
            result.total_feature_price = totalFeaturePricePerMonth;
            result.total_price = mokaPrice + totalFeaturePricePerMonth;
            resultProrate.push(result);
            currentState = nextState;
          }
        }
      }
    });
    return resultProrate;
  }

  _endOfNextPlan = format => {
    const {
      currentSubscriptionRules,
      expired,
      rules,
      outletMinMaxDate,
      couponDiscount,
      billingCouponV2Enabled,
    } = this.props;
    let extendDate = '';
    if (expired) {
      const subscriptionPlans = rules.subscription_plans;
      const monthRules = currentSubscriptionRules.month;
      if (subscriptionPlans) {
        extendDate =
          subscriptionPlans.length === 1
            ? moment()
            : moment().add(monthRules, 'month');
      } else {
        extendDate = moment();
      }
    } else {
      const maxDate = moment(outletMinMaxDate.maxDate, 'DD/MM/YYYY');
      extendDate = maxDate.add(currentSubscriptionRules.month, 'month');
    }

    // billing coupon add months
    if (billingCouponV2Enabled && couponDiscount.additionalMonth) {
      extendDate = extendDate.add(couponDiscount.additionalMonth, 'month');
    }

    let extendDateFormatted;
    if (expired) {
      extendDateFormatted = extendDate.format('D MMMM YYYY');
    } else {
      extendDateFormatted = extendDate.format(format);
    }

    this.props.dispatch(setExtendDate(extendDateFormatted));
    return extendDateFormatted;
  };
}

const mapForm = {
  form: 'BillingReceipt',
};

function mapStateToProps(state) {
  const {
    id,
    business_type_id,
    business_category_id,
    is_enterprise,
    is_mokapos_user: isMokaposUser,
  } = state.moka.user.business;
  const {
    isValidatingCoupon,
    couponDiscount,
    isCouponValid,
    couponErrorMessage,
    outlets,
    rules,
    currentSubscriptionRules,
    pendingPaymentMessage,
    unusedOutletMessage,
    featureSubscriptionStatus,
    featureSubscriptionPrice,
    isDeleted,
    purchasedStaffs,
    isExtended,
    outletMinMaxDate,
    isProgressCursor,
    showProrate,
    extendDate,
    minMaxAllOutlet,
    totalBillingPrice,
    showMarkSubscriptionModal,
    paramsDeactive,
    totalOutletPrice,
    totalFeaturePrice,
    showSlotEmployee,
    proratePricePeriods,
    staffSlotsPrice,
  } = state.setting.billing;
  const { expired } = state.subscriptionExpired;
  return {
    outlets,
    rules,
    currentSubscriptionRules,
    pendingPaymentMessage,
    unusedOutletMessage,
    featureSubscriptionStatus,
    featureSubscriptionPrice,
    expired,
    isDeleted,
    isCouponValid,
    couponDiscount,
    couponErrorMessage,
    isValidatingCoupon,
    businessId: id,
    businessTypeId: business_type_id,
    businessCategoryId: business_category_id,
    billingForm: getFormValues('BillingReceipt')(state),
    purchasedStaffs,
    isExtended,
    outletMinMaxDate,
    isProgressCursor,
    showProrate,
    extendDate,
    minMaxAllOutlet,
    totalBillingPrice,
    showMarkSubscriptionModal,
    paramsDeactive,
    totalOutletPrice,
    totalFeaturePrice,
    showSlotEmployee,
    isEnterprise: is_enterprise,
    isMokaposUser,
    proratePricePeriods,
    staffSlotsPrice,
  };
}

function mapDispatchToProps(dispatch) {
  return { dispatch };
}

const connected = connect(
  mapStateToProps,
  mapDispatchToProps
)(reduxForm(mapForm)(BillingReceiptForm));

const mapFlagsToProps = flags => ({
  billingCouponV2Enabled: flags.billingCouponV2,
});

export default withFeatureFlags(mapFlagsToProps)(connected);
